module.exports = __webpack_public_path__ + "img/puntafiames.59075860.jpg";